/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import '../styles/styles.css';
import SingleStaveHandler from "../common/singleStaveHandler";
import { SharpButtons } from "./buttons/QuestionSharpButtons";
import { ListeningPlayButton } from "./ListeningPlayButton";


interface TopNavBarProps {
    handler: SingleStaveHandler | null;
    isLianEr: boolean;
    dataJson: any;
}

function QuestionsTopNavBar({ handler, isLianEr, dataJson }: TopNavBarProps) {
    return (
        <div className="question-top-nav-bar">
            {isLianEr && <ListeningPlayButton handler={handler} dataJson={dataJson}/>}
            <SharpButtons handler={handler} isLianEr={isLianEr}/>
        </div>
    );
}

export default QuestionsTopNavBar;
